import { titleCase } from 'title-case';

const formatProviderName = (provider: any) => {
  const first = provider.first_name
    ? titleCase(provider.first_name.toLowerCase())
    : null;

  const last = provider.last_name
    ? titleCase(provider.last_name.toLowerCase())
    : null;

  const org_name = provider.organization_name
    ? titleCase(provider.organization_name.toLowerCase())
    : null;

  return first ? first + ' ' + last : org_name ?? '(No Name)';
};

export default formatProviderName;
